import React from "react";
import { Link } from "react-router-dom";
import "./members.css";

export const Members = (props) => {
  return (
    <div className="big-box">
      <div className="heading">
        <h1>{props.heading}</h1>
      </div>
      <div className="medium-box">
        {props.Name.map((Name, index) => {
          return (
            <div className="small-box">
              <div className="personal-img">
                <img src={props.Pic[index]} pho alt="" />
                <div className="icon">
                  {(() => {
                    if (props.P_website[index] !== "") {
                      return (
                        <Link
                          to={props.P_website[index]}
                          className="btn btn-custom"
                        >
                          Personal webpage
                        </Link>
                      );
                    }
                  })()}
                </div>
              </div>
              <div className="personal-body">
                <p className="personal-name">{props.Name[index]}</p>
                <p className="personal-text">{props.Info[index]}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
